window.addEventListener('load', () => {
  document.querySelectorAll('deferred-media').forEach(el => {
    const playButton = el.querySelector('.deferred-media__poster-button');
    if (playButton) playButton.click();
    
    setTimeout(() => {
      const video = el.querySelector('video');
      if (video) video.play();
    }, 100);
  });
});
// Taille unique : remplacer le texte par un bouton sélectionné
document.querySelectorAll('[data-testid="variant-option-single"]').forEach(el => {
  const value = el.querySelector('.variant-option__swatch-value');
  if (!value) return;
  
  const text = value.textContent.trim();
  
  const fieldset = document.createElement('fieldset');
  fieldset.className = 'variant-option variant-option--buttons variant-option--equal-width-buttons';
  
  fieldset.innerHTML = `
    <legend>Taille</legend>
    <label class="variant-option__button-label">
      <input type="radio" checked disabled style="display:none">
      <span>${text}</span>
    </label>
  `;
  
  el.replaceWith(fieldset);
});

// Taille unique : mention "convient du 36 au 42"
(function() {
  setTimeout(() => {
    const allFieldsets = document.querySelectorAll('.variant-option--buttons');
    allFieldsets.forEach(fieldset => {
      const legend = fieldset.querySelector('legend');
      const labels = fieldset.querySelectorAll('.variant-option__button-label');
      if (legend && legend.textContent.trim() === 'Taille' && labels.length === 1) {
        if (!fieldset.querySelector('.taille-unique-hint')) {
          // Wrapper flex pour aligner bouton + texte
          const wrapper = document.createElement('div');
          wrapper.style.cssText = 'display: flex; align-items: center; gap: 12px;';
          
          // Déplacer le label dans le wrapper
          const label = labels[0];
          fieldset.insertBefore(wrapper, label);
          wrapper.appendChild(label);
          
          const hint = document.createElement('p');
          hint.className = 'taille-unique-hint';
          hint.textContent = 'Convient du 36 au 42';
          hint.style.cssText = 'margin: 0; font-size: 0.95em; color: #666;';
          wrapper.appendChild(hint);
        }
      }
    });
  }, 200);
})();



// Sticky ATC
(function() {
  const originalForm = document.querySelector('[data-type="add-to-cart-form"]');
  if (!originalForm) return;

  const originalBtn = originalForm.querySelector('[ref="addToCartButton"]');
  const originalBtnContainer = originalForm.querySelector('[ref="addToCartButtonContainer"]');
  const variantPicker = document.querySelector('variant-picker');

  // Cloner le bouton original entièrement
  const clonedBtnContainer = originalBtnContainer
    ? originalBtnContainer.cloneNode(true)
    : null;

  // Barre sticky
  const stickyBar = document.createElement('div');
  stickyBar.id = 'sticky-atc-bar';
  stickyBar.appendChild(
    clonedBtnContainer || Object.assign(document.createElement('button'), {
      className: 'button add-to-cart-button button',
      textContent: 'Ajouter au panier'
    })
  );

  // Panneau slide-up
  const panel = document.createElement('div');
  panel.id = 'sticky-atc-panel';
  panel.innerHTML = `
    <div id="sticky-atc-overlay"></div>
    <div id="sticky-atc-drawer">
      <button id="sticky-atc-close">✕</button>
      <div id="sticky-atc-variants"></div>
    </div>
  `;

  // Cloner le bouton pour le panneau aussi
  const clonedBtnPanel = originalBtnContainer
    ? originalBtnContainer.cloneNode(true)
    : null;
  if (clonedBtnPanel) {
    clonedBtnPanel.id = 'sticky-atc-confirm-container';
    document.getElementById && panel.querySelector('#sticky-atc-drawer').appendChild(clonedBtnPanel);
  }

  document.body.appendChild(stickyBar);
  document.body.appendChild(panel);

  if (variantPicker) {
    const clone = variantPicker.cloneNode(true);
    clone.id = 'sticky-variant-picker-clone';
    panel.querySelector('#sticky-atc-variants').appendChild(clone);
  }

  const style = document.createElement('style');
  style.textContent = `
    #sticky-atc-bar {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 12px 16px;
      background: white;
      box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
      z-index: 999;
      opacity: 0;
      transform: translateY(100%);
      transition: opacity 0.3s ease, transform 0.3s ease;
      pointer-events: none;
    }
    #sticky-atc-bar.visible {
      opacity: 1;
      transform: translateY(0);
      pointer-events: auto;
    }
    #sticky-atc-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.4);
      z-index: 1000;
    }
    #sticky-atc-drawer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background: white;
      padding: 24px 16px;
      z-index: 1001;
      border-radius: 12px 12px 0 0;
      transform: translateY(100%);
      transition: transform 0.3s ease;
    }
    #sticky-atc-panel.open #sticky-atc-drawer {
      transform: translateY(0);
    }
    #sticky-atc-panel { display: none; }
    #sticky-atc-panel.open { display: block; }
    #sticky-atc-close {
      position: absolute;
      top: 12px;
      right: 16px;
      background: none;
      border: none;
      font-size: 18px;
      cursor: pointer;
    }
    #sticky-atc-confirm-container,
    #sticky-atc-bar add-to-cart-component,
    #sticky-atc-bar button {
      width: 100%;
      margin-top: 0;
    }
    #sticky-atc-confirm-container { margin-top: 16px; }
  `;
  document.head.appendChild(style);

  // Observer
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      stickyBar.classList.toggle('visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });

  if (originalBtn) observer.observe(originalBtn);

  // Ouvrir panneau au clic sur la barre
  stickyBar.addEventListener('click', () => {
    panel.classList.add('open');
  });

  // Fermer panneau
  function closePanel() { panel.classList.remove('open'); }
  panel.querySelector('#sticky-atc-close').addEventListener('click', closePanel);
  panel.querySelector('#sticky-atc-overlay').addEventListener('click', closePanel);

  // Ajouter au panier depuis le panneau
  const confirmBtn = panel.querySelector('button[name="add"]');
  if (confirmBtn) {
    confirmBtn.addEventListener('click', (e) => {
      e.preventDefault();

      const cloneInputs = panel.querySelectorAll('input[type="radio"]:checked');
      cloneInputs.forEach(input => {
        const original = originalForm.querySelector(`input[name="${input.name}"]`);
        if (original) {
          original.value = input.value;
          original.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      originalBtn.click();

      setTimeout(() => {
        closePanel();
        stickyBar.classList.remove('visible');
        setTimeout(() => {
          if (originalBtn) observer.observe(originalBtn);
        }, 3000);
      }, 500);
    });
  }
})();
// Carousel Look sur collection.look
(function() {
  // Détecter via le data-template sur le main
  const main = document.querySelector('[data-template="collection"]');
  if (!main) return;

  // Vérifier que c'est bien une collection Look via l'URL
  if (!window.location.pathname.includes('/collections/look')) return;

  const grid = document.querySelector('ul.product-grid[data-testid="product-grid"]');
  if (!grid) return;

  // Masquer les filtres
  const filters = document.querySelector('.facets-block-wrapper');
  if (filters) filters.style.display = 'none';

  // Transformer en carousel
  grid.style.cssText = `
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    gap: 12px;
    padding: 0 16px 12px;
  `;

  grid.querySelectorAll('li.product-grid__item').forEach(card => {
    card.style.cssText = `
      flex: 0 0 70vw !important;
      max-width: 340px;
      scroll-snap-align: start;
      width: auto !important;
    `;
  });
})();
// Masquer le titre sur les pages collection Look
(function() {
  if (!window.location.pathname.includes('/collections/look')) return;

  const titre = document.querySelector('h1');
  if (titre) titre.style.display = 'none';
})();
// --- Cart Shipping Preview ---
(function () {
  const THRESHOLD = 6900;

  function getCartTotal() {
    return fetch('/cart.js')
      .then(r => r.json())
      .then(data => data.total_price);
  }

  function buildShippingBlock(totalPrice) {
    const isFree = totalPrice >= THRESHOLD;

    const mondialPrice = isFree
      ? `<span class="cart-shipping-preview__free">Gratuit</span>`
      : `<span>4,90 €</span>`;

    const colissimoPrice = isFree
      ? `<span class="cart-shipping-preview__original">9,90 €</span>
         <span class="cart-shipping-preview__discounted">4,95 € (-50%)</span>`
      : `<span>9,90 €</span>`;

    return `
      <div class="cart-shipping-preview" id="cart-shipping-preview">
        <p class="cart-shipping-preview__title">Livraison en France</p>
        <label class="cart-shipping-preview__option">
          <input type="radio" name="shipping-preview" value="mondial-relay" checked>
          <span>Mondial Relay</span>
          <span class="cart-shipping-preview__price">${mondialPrice}</span>
        </label>
        <label class="cart-shipping-preview__option">
          <input type="radio" name="shipping-preview" value="colissimo">
          <span>Colissimo</span>
          <span class="cart-shipping-preview__price">${colissimoPrice}</span>
        </label>
      </div>
    `;
  }

  let isInjecting = false;

  function injectIfMissing(container) {
    if (isInjecting) return;
    if (document.getElementById('cart-shipping-preview')) return;

    const ctas = container
      ? container.querySelector('.cart__ctas')
      : document.querySelector('.cart__ctas');

    if (!ctas) return;

    isInjecting = true;
    getCartTotal().then(total => {
      if (!document.getElementById('cart-shipping-preview')) {
        const ctas2 = document.querySelector('.cart__ctas');
        if (ctas2) ctas2.insertAdjacentHTML('beforebegin', buildShippingBlock(total));
      }
      isInjecting = false;
    });
  }

  function observeCartZone() {
    // Cible uniquement le drawer ou la page panier, pas tout le body
    const targets = [
      document.querySelector('.cart-drawer'),
      document.querySelector('.cart-drawer__summary'),
      document.querySelector('cart-drawer'),
      document.querySelector('[id*="cart"]'),
      document.querySelector('main'),
    ].filter(Boolean);

    const target = targets[0] || document.body;

    const observer = new MutationObserver((mutations) => {
      // Ignore les mutations causées par notre propre injection
      const isOwnMutation = mutations.every(m =>
        [...m.addedNodes].some(n => n.id === 'cart-shipping-preview')
      );
      if (isOwnMutation) return;

      injectIfMissing(target);
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    injectIfMissing();
    observeCartZone();
  });
})();



